import {
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  ModalBody,
  Text
} from '@chakra-ui/react';
import { ModalBuild } from 'components/molecules';
import { ModalBuildHandle } from 'components/molecules/ModalBuild/interfaces';
import { ContractSearchResponseDTO } from 'models';
import {
  AccordionButtonCustom,
  AccordionCustom
} from 'pages/Contract/components/ContractDetail/styles';
import {
  forwardRef
} from 'react';
import { ViewComplementaryDataFormReadOnly } from '../ViewFormsReadOnly/ViewComplementaryDataFormReadOnly';
import { ViewConsortiumFormReadOnly } from '../ViewFormsReadOnly/ViewConsortiumFormReadOnly';
import { ViewContractFormReadOnly } from '../ViewFormsReadOnly/ViewContractFormReadOnly';
import { ViewCreditorFormReadOnly } from '../ViewFormsReadOnly/ViewCreditorFormReadOnly';
import { ViewDebtorFormReadOnly } from '../ViewFormsReadOnly/ViewDebtorFormReadOnly';
import { ViewFinancingFormReadOnly } from '../ViewFormsReadOnly/ViewFinancingFormReadOnly';
import { ViewVehicleFormReadOnly } from '../ViewFormsReadOnly/ViewVehicleFormReadOnly';

interface DetailsModalProps {
  onClose: () => void;
  contract: ContractSearchResponseDTO | null;
}

export const DetailsModal = forwardRef<ModalBuildHandle, DetailsModalProps>(
  ({ onClose, contract }, ref) => {

    if (!contract) {
      return null;
    }

    const accordions = [
      { label: 'Dados do veículo', content: <ViewVehicleFormReadOnly contract={contract} /> },
      { label: 'Dados do contrato', content: <ViewContractFormReadOnly contract={contract} /> },
      { label: 'Dados do financiamento', content: <ViewFinancingFormReadOnly contract={contract} /> },
      { label: 'Dados do credor', content: <ViewCreditorFormReadOnly contract={contract} /> },
      { label: 'Dados do devedor', content: <ViewDebtorFormReadOnly contract={contract} /> },
      { label: 'Consórcio', content: <ViewConsortiumFormReadOnly contract={contract} /> },
      { label: 'Dados complementares', content: <ViewComplementaryDataFormReadOnly contract={contract} /> }
    ];

return (
      <ModalBuild
        ref={ref}
        size="4xl"
        onAfterClose={onClose}
        title="Detalhes do Contrato" // 1. Passamos o título como uma prop
      >
        <ModalBody pb={6}>
          <AccordionCustom allowToggle defaultIndex={[0]}>
            {accordions.map(({ label, content }, key) => (
              <AccordionItem key={key}>
                <h2>
                  <AccordionButtonCustom>
                    <Box flex="1" textAlign="left">
                      <Text fontWeight="700">{label}</Text>
                    </Box>
                    <AccordionIcon fontSize="24px" />
                  </AccordionButtonCustom>
                </h2>
                <AccordionPanel p={'16px 0px'}>{content}</AccordionPanel>
              </AccordionItem>
            ))}
          </AccordionCustom>
        </ModalBody>
      </ModalBuild>
    );
  }
);